/* build:2026-06-03-nav */
(function () {
  'use strict';

  var STORAGE_KEY = 'wkn_pending_note';

  function initLeaveNoteForms() {
    document.querySelectorAll('[data-wkn-form]').forEach(function (form) {
      if (form.dataset.wknBound) return;
      form.dataset.wknBound = '1';

      var firstName = form.querySelector('[data-wkn-first-name]');
      var lastInitial = form.querySelector('[data-wkn-last-initial]');
      var nameField = form.querySelector('[data-wkn-display-name]');
      var photoInput = form.querySelector('[data-wkn-photo]');
      var endpoint = form.getAttribute('data-wkn-endpoint');
      var endpointPlain = form.getAttribute('data-wkn-endpoint-plain');

      if (lastInitial) {
        lastInitial.addEventListener('input', function () {
          lastInitial.value = lastInitial.value.replace(/[^a-zA-Z]/g, '').slice(0, 1).toUpperCase();
        });
      }

      if (photoInput) {
        photoInput.addEventListener('change', function () {
          var preview = form.querySelector('[data-wkn-preview]');
          var img = form.querySelector('[data-wkn-preview-img]');
          if (!preview || !img || !photoInput.files || !photoInput.files[0]) return;
          var reader = new FileReader();
          reader.onload = function (e) {
            img.src = e.target.result;
            preview.hidden = false;
          };
          reader.readAsDataURL(photoInput.files[0]);
        });
      }

      form.addEventListener('submit', function (e) {
        var err = form.querySelector('[data-wkn-error]');
        if (err) err.hidden = true;

        var fname = firstName ? firstName.value.trim() : '';
        var initial = lastInitial ? lastInitial.value.trim().toUpperCase() : '';
        var noteEl = form.querySelector('[data-wkn-note]');

        if (!fname) {
          e.preventDefault();
          showError(form, 'Please add your first name.');
          if (firstName) firstName.focus();
          return;
        }
        if (!noteEl || !noteEl.value.trim()) {
          e.preventDefault();
          showError(form, 'Please write your note.');
          if (noteEl) noteEl.focus();
          return;
        }

        var display = initial ? fname + ' ' + initial + '.' : fname;
        if (nameField) nameField.value = display;

        var hasPhoto = photoInput && photoInput.files && photoInput.files[0];

        savePendingNote(form, display, noteEl.value.trim(), hasPhoto ? photoInput.files[0] : null)
          .then(function () {
            if (hasPhoto && endpointPlain) {
              e.preventDefault();
              form.action = endpointPlain;
              form.removeAttribute('data-wkn-endpoint');
              form.submit();
              return;
            }

            e.preventDefault();
            if (!endpoint) {
              showError(form, 'Form is not configured. Email info@wudykitchen.com instead.');
              return;
            }
            submitNoteAjax(form, endpoint, display, noteEl);
          })
          .catch(function () {
            e.preventDefault();
            showError(form, 'Could not save your note preview. Try again or email info@wudykitchen.com.');
          });
      });
    });
  }

  function savePendingNote(form, displayName, noteText, photoFile) {
    return new Promise(function (resolve) {
      var payload = {
        displayName: displayName,
        note: noteText,
        photo: null,
        at: Date.now()
      };

      if (!photoFile) {
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        } catch (e) { /* ignore */ }
        resolve();
        return;
      }

      var reader = new FileReader();
      reader.onload = function (ev) {
        payload.photo = ev.target.result;
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        } catch (e) {
          payload.photo = null;
          try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
          } catch (e2) { /* ignore */ }
        }
        resolve();
      };
      reader.onerror = function () {
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        } catch (e) { /* ignore */ }
        resolve();
      };
      reader.readAsDataURL(photoFile);
    });
  }

  function readPendingNote() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearPendingNote() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* ignore */ }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderPendingCard(payload) {
    var photoHtml = '';
    if (payload.photo) {
      photoHtml =
        '<div class="wkn-card__photo-wrap"><img class="wkn-card__photo" src="' +
        payload.photo +
        '" alt="" width="400" height="280" loading="lazy"></div>';
    }

    var heroClass = payload.photo
      ? ' wkn-card--with-photo wkn-card--hero-scene'
      : '';
    var topHtml = payload.photo
      ? ''
      : '<div class="wkn-card__top"><div class="wkn-card__avatar wkn-card__avatar--initial" aria-hidden="true">' +
        escapeHtml(payload.displayName.charAt(0)) +
        '</div></div>';
    return (
      '<article class="wkn-card wkn-card--pinned wkn-card--pending' +
      heroClass +
      ' wkn-card--hue-2 wkn-card--tilt-1">' +
      '<span class="wkn-pin" aria-hidden="true"><span class="wkn-pin__head"></span><span class="wkn-pin__needle"></span></span>' +
      '<span class="wkn-card__badge">Pending review</span>' +
      topHtml +
      photoHtml +
      '<blockquote class="wkn-card__quote">' +
      escapeHtml(payload.note) +
      '</blockquote>' +
      '<footer class="wkn-card__foot">' +
      '<div class="wkn-card__meta">' +
      '<cite class="wkn-card__name">' +
      escapeHtml(payload.displayName) +
      '</cite>' +
      '<time class="wkn-card__date">Just pinned</time>' +
      '</div></footer></article>'
    );
  }

  function mountPendingOnWall() {
    var payload = readPendingNote();
    if (!payload) return;

    var host = document.querySelector('[data-wkn-pending-host]');
    var grid = document.querySelector('[data-wkn-wall-grid]');
    if (!host || !grid) return;

    host.innerHTML = renderPendingCard(payload);
    host.hidden = false;
    grid.insertBefore(host, grid.firstChild);

    if (window.location.search.indexOf('note-sent=1') !== -1) {
      var wall = document.querySelector('.wkn-wall');
      if (wall) {
        var smooth =
          window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        wall.scrollIntoView({ behavior: smooth ? 'smooth' : 'instant', block: 'start' });
      }
    }
  }

  function showFormSuccessFromReturn() {
    if (window.location.search.indexOf('note-sent=1') === -1) return;

    var form = document.querySelector('[data-wkn-form]');
    if (!form) return;

    showSuccess(form);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.delete('note-sent');
      window.history.replaceState({}, '', url.pathname + url.hash);
    }
  }

  function showError(form, msg) {
    var el = form.querySelector('[data-wkn-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function submitNoteAjax(form, endpoint, displayName, noteEl) {
    var btn = form.querySelector('[data-wkn-submit]');
    if (btn) btn.disabled = true;

    var fd = new FormData();
    fd.append('_subject', 'Wudy Kitchen note from ' + displayName);
    fd.append('_captcha', 'false');
    fd.append('_template', 'table');
    fd.append('Name', displayName);
    fd.append('Note', noteEl.value.trim());
    if (photoInput && photoInput.files && photoInput.files[0]) {
      fd.append('attachment', photoInput.files[0]);
    }

    fetch(endpoint, {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        var ok =
          result.ok &&
          (result.data.success === true ||
            result.data.success === 'true' ||
            result.data.success === 'OK');
        if (!ok) {
          throw new Error(result.data.message || 'Submission failed');
        }
        mountPendingOnWall();
        showSuccess(form);
        form.reset();
        var preview = form.querySelector('[data-wkn-preview]');
        if (preview) preview.hidden = true;
      })
      .catch(function (err) {
        var msg =
          'Something went wrong sending your note. Email info@wudykitchen.com with your note and photo.';
        if (err && err.message && err.message.indexOf('activate') !== -1) {
          msg =
            'Form still needs activation — check info@wudykitchen.com for a FormSubmit activation link, then try again.';
        }
        showError(form, msg);
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  }

  function showSuccess(form) {
    var ok = form.querySelector('[data-wkn-success]');
    var fields = form.querySelector('[data-wkn-fields]');
    if (ok) ok.hidden = false;
    if (fields) fields.hidden = true;
  }

  function getFixedHeaderOffset() {
    var total = 12;
    var header = document.querySelector('.section-header, .wudy-header, header.header');
    if (header) {
      total += header.offsetHeight || header.getBoundingClientRect().height || 0;
    }
    var announce = document.querySelector('.announcement-bar-section, .shopify-section-group-header-group .announcement-bar');
    if (announce && !header) {
      total += announce.offsetHeight || 0;
    }
    return Math.ceil(total);
  }

  function scrollToLeaveNote(target, behavior) {
    if (!target) return;
    var offset = getFixedHeaderOffset();
    var top = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - offset;
    var resolved = behavior;
    if (!resolved) {
      var smooth =
        window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      resolved = smooth ? 'smooth' : 'auto';
    }
    window.scrollTo({ top: Math.max(0, top), behavior: resolved });
  }

  function initScrollToLeave() {
    document.querySelectorAll('[data-wkn-scroll-leave]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var target = document.getElementById('leave-a-note');
        if (!target) return;
        e.preventDefault();
        var scrollY = window.scrollY || window.pageYOffset || 0;
        var nextUrl = window.location.pathname + window.location.search + '#leave-a-note';
        if (window.location.hash !== '#leave-a-note' && history.pushState) {
          history.pushState({ wudyHash: true, wudyScrollY: scrollY }, '', nextUrl);
        }
        scrollToLeaveNote(target, 'smooth');
      });
    });
  }

  function initHashLeaveNote() {
    if (location.hash !== '#leave-a-note') return;
    var target = document.getElementById('leave-a-note');
    if (!target) return;

    function align() {
      scrollToLeaveNote(target, 'instant');
    }

    if (document.readyState === 'complete') {
      requestAnimationFrame(function () {
        requestAnimationFrame(align);
      });
    } else {
      window.addEventListener(
        'load',
        function () {
          requestAnimationFrame(function () {
            requestAnimationFrame(align);
          });
        },
        { once: true }
      );
    }
  }

  function initFabFormAvoidance() {
    var leave = document.getElementById('leave-a-note');
    if (!leave || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          document.body.classList.toggle('wkn-leave-form-visible', entry.isIntersecting && entry.intersectionRatio > 0.12);
        });
      },
      { root: null, rootMargin: '0px 0px -12% 0px', threshold: [0, 0.12, 0.35] }
    );
    io.observe(leave);
  }

  function initPendingOnLoad() {
    mountPendingOnWall();
    showFormSuccessFromReturn();
  }

  function initMomentProductImages() {
    var page = document.querySelector('.wkn-page[data-wkn-moment-map]');
    if (!page) return;
    var map = {};
    try {
      map = JSON.parse(page.getAttribute('data-wkn-moment-map') || '{}');
    } catch (e) {
      return;
    }
    document.querySelectorAll('.wkn-moment').forEach(function (card) {
      var link = card.querySelector('.wkn-moment__product');
      if (!link || !link.pathname) return;
      var parts = link.pathname.split('/products/');
      if (parts.length < 2) return;
      var handle = parts[1].split('?')[0].split('#')[0];
      var url = map[handle];
      if (!url) return;
      var img = card.querySelector('.wkn-moment__photo');
      if (!img) return;
      img.src = url;
      card.classList.add('wkn-moment--product-photo');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLeaveNoteForms();
      initScrollToLeave();
      initHashLeaveNote();
      initFabFormAvoidance();
      initPendingOnLoad();
      initMomentProductImages();
    });
  } else {
    initLeaveNoteForms();
    initScrollToLeave();
    initHashLeaveNote();
    initFabFormAvoidance();
    initPendingOnLoad();
    initMomentProductImages();
  }
})();
